<app-map></app-map>
<div class="logo-container" routerLink="/">
    <img class="logo" src={{logo}}>
</div>
<div class="components-container">
    <div class="overlay" [class.d-none]="isSpotlight">
        <router-outlet></router-outlet>
    </div>
    <div class="bottom-cards-container">
        <app-card-small [class.d-none]="isSpotlight"></app-card-small>
        <app-card-xsmall (onSpotlightToggle)="onSpotlightToggle($event)"></app-card-xsmall>
    </div>
</div>